import z from "zod";

export const disqualifyProposalSchema = z.object({
  reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type DisqualifyProposalValidationSchema = z.infer<typeof disqualifyProposalSchema>;
